import type { BrandSource } from './types';
import { namesABrand } from './types';

// gloss
export const resourceBrandSource: BrandSource = {
  name: 'resource',
  resolve: ({ resource }) => (namesABrand(resource ?? null) ? (resource ?? null) : null),
};
